import styled from 'styled-components';
import ChartHeaderDisplay from './ChartHeaderDisplay';
import * as ChartUI from '../ChartUI';
import { ChartMode } from '../types';

interface IProps {
  mode: ChartMode;
  chartTitle: string;
  updateChartTitle?: (newValue: string) => Promise<void>;
}

const Wrapper = styled.div`
  align-self: flex-start;
`;

const LoadingChartHeader = ({ mode, chartTitle, updateChartTitle }: IProps) => (
  <ChartUI.Header $mode={mode} $isDisabled={true}>
    <Wrapper>
      <ChartHeaderDisplay
        mode={mode}
        chartTitle={chartTitle}
        updateChartTitle={updateChartTitle}
      />
    </Wrapper>
  </ChartUI.Header>
);

export default LoadingChartHeader;
